import { styled } from '@mui/material/styles';

export const DateOfBirthFormInputContainer = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
}));

export const DateOfBirthFormInputErrorMessage = styled('span', {
	shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
	display: error ? 'block' : 'none',
	...theme.typography.b2,
	color: theme.palette.error.main,
}));
